import {
  IElement,
  IElementFixture,
} from "core-integration/src/store/elements/types";
import { IFixture } from "core-integration/src/store/fixtures/types";
import { ITeamsById } from "core-integration/src/store/teams/types";
import React from "react";

interface IProps {
  fixture: IFixture | IElementFixture;
  element: IElement;
  teamsById: ITeamsById;
}

const FixtureForElement: React.FC<IProps> = ({
  fixture,
  element,
  teamsById,
}) => {
  const isHome = element.team === fixture.team_h;
  return isHome ? (
    <span>{teamsById[fixture.team_a].short_name} (H)</span>
  ) : (
    <span>{teamsById[fixture.team_h].short_name} (A)</span>
  );
};

export default FixtureForElement;

interface IMultiProps {
  delimiter?: React.ReactNode;
  fixtures: IFixture[];
  element: IElement;
  teamsById: ITeamsById;
}

export const FixturesForElement: React.FC<IMultiProps> = ({
  delimiter = ", ",
  fixtures,
  element,
  teamsById,
}) => {
  const fragments = fixtures.map((f) => (
    <FixtureForElement
      element={element}
      fixture={f}
      teamsById={teamsById}
      key={f.id}
    />
  ));
  return fragments.length
    ? fragments.reduce((result, item) => (
        <>
          {result}
          {delimiter}
          {item}
        </>
      ))
    : null;
};
